const Privacy = () => {
    return (
        <div className="container my-4" dir="rtl">
            <h1 className="mb-4">سیاست حفظ حریم خصوصی</h1>
            <p>
                12157152 CANADA LTD ("پرپال"، "ما"، یا "ما") متعهد به حفظ حریم خصوصی افرادی است که با پلتفرم‌های
                نرم‌افزاری اداره شده توسط مشتریان ما تعامل دارند. این سیاست حفظ حریم خصوصی نحوه جمع‌آوری، استفاده، افشا
                و محافظت از اطلاعات شما را هنگام دسترسی به خدمات یا وب‌سایت ساخته شده و پشتیبانی شده توسط پلتفرم پرپال
                ("خدمات") شرح می‌دهد.
            </p>

            <section>
                <h2>۱. تعریف اطلاعات شخصی</h2>
                <p>
                    "اطلاعات شخصی" به معنای اطلاعات درباره یک فرد قابل شناسایی است، به استثنای اطلاعات تماس تجاری. این
                    شامل
                    اما نه محدود به نام، جزئیات تماس، شناسه صادر شده توسط دولت، جزئیات مالی و آدرس IP شما می‌شود.
                </p>
            </section>

            <section>
                <h2>۲. مبنای قانونی و رضایت</h2>
                <p>
                    با دسترسی یا استفاده از خدمات، یا ارسال اطلاعات شخصی به ما یا به مشتری که سرویس را اداره می‌کند، شما
                    به
                    جمع‌آوری، استفاده، افشا و پردازش اطلاعات شخصی خود همانطور که در این سیاست حفظ حریم خصوصی توضیح داده
                    شده
                    است، رضایت می‌دهید. ما چنین داده‌هایی را مطابق با قوانین حریم خصوصی کانادا، از جمله قانون حفاظت از
                    اطلاعات شخصی و اسناد الکترونیکی (PIPEDA) مدیریت می‌کنیم.
                </p>
            </section>

            <section>
                <h2>۳. اطلاعاتی که ما جمع‌آوری می‌کنیم</h2>
                <h3>۳.۱ اطلاعاتی که شما ارائه می‌دهید</h3>
                <ul>
                    <li>نام، آدرس، ایمیل، شماره تلفن</li>
                    <li>اطلاعات مالی و پرداخت</li>
                    <li>اسناد تأیید هویت</li>
                    <li>اطلاعات پروفایل (طبق درخواست مشتری)</li>
                </ul>

                <h3>۳.۲ اطلاعات فنی</h3>
                <ul>
                    <li>آدرس IP، نوع دستگاه و مرورگر</li>
                    <li>سیستم عامل و منطقه زمانی</li>
                    <li>داده‌های بازدید صفحه، الگوهای ناوبری و گزارش‌های فعالیت</li>
                </ul>

                <h3>۳.۳ اطلاعات از اشخاص ثالث</h3>
                <ul>
                    <li>تأیید هویت یا تراکنش از بانک‌ها یا ارائه‌دهندگان خدمات</li>
                    <li>داده‌های ورود از حساب‌های شبکه‌های اجتماعی در صورت استفاده برای احراز هویت</li>
                    <li>بررسی‌های انطباق از ابزارهای تأیید هویت شخص ثالث</li>
                </ul>
            </section>

            <section>
                <h2>۴. استفاده از کوکی‌ها و فناوری‌های ردیابی</h2>
                <p>
                    ما و مشتریان ما ممکن است از کوکی‌ها، پیکسل‌ها و ابزارهای تحلیلی برای موارد زیر استفاده کنیم:
                </p>
                <ul>
                    <li>اطمینان از عملکرد و امنیت پلتفرم</li>
                    <li>شخصی‌سازی و بهبود تجربه کاربر</li>
                    <li>تحلیل استفاده از سرویس برای بهبود</li>
                </ul>
                <p>
                    کاربران می‌توانند کوکی‌ها را از طریق تنظیمات مرورگر مدیریت کنند. محدود کردن کوکی‌ها ممکن است بر
                    عملکرد
                    سرویس تأثیر بگذارد.
                </p>
            </section>

            <section>
                <h2>۵. استفاده از اطلاعات شخصی</h2>
                <p>
                    اطلاعات شخصی ممکن است توسط مشتری و/یا ما برای موارد زیر استفاده شود:
                </p>
                <ul>
                    <li>ارائه خدمات درخواستی</li>
                    <li>تأیید هویت (KYC/AML)</li>
                    <li>جلوگیری از تقلب و تضمین امنیت</li>
                    <li>بهبود پلتفرم و تجربه کاربر</li>
                    <li>ارسال ارتباطات مرتبط با خدمات</li>
                </ul>
                <p>
                    پرپال همچنین ممکن است داده‌ها را برای انجام تعهدات قراردادی پشتیبانی به مشتریان ما پردازش کند.
                </p>
            </section>

            <section>
                <h2>۶. افشای اطلاعات شخصی</h2>
                <p>
                    اطلاعات شخصی شما ممکن است برای موارد زیر افشا شود:
                </p>
                <ul>
                    <li><strong>مشتریان:</strong> ارائه‌دهنده خدمات (مشتری) که با آن ثبت‌نام کرده‌اید کنترل کامل حساب و
                        داده‌های شخصی شما را در نمونه سرویس خود دارد.
                    </li>
                    <li><strong>ارائه‌دهندگان خدمات:</strong> فروشندگان تأیید هویت، ارائه‌دهندگان میزبانی زیرساخت و
                        خدمات
                        تحلیلی
                    </li>
                    <li><strong>مقامات قانونی یا نظارتی:</strong> در پاسخ به درخواست‌های قانونی، از جمله FINTRAC یا سایر
                        تنظیم‌کنندگان
                    </li>
                    <li><strong>معاملات تجاری:</strong> اگر پرپال تحت فروش، ادغام یا تجدید ساختار قرار گیرد</li>
                </ul>
                <p>
                    پرپال کنترل یا مسئولیتی در قبال نحوه استفاده یا افشای داده‌ها توسط مشتریان فردی فراتر از مسئولیت‌های
                    آنها تحت توافقنامه پلتفرم ما ندارد.
                </p>
            </section>

            <section>
                <h2>۷. حفظ داده‌ها</h2>
                <p>
                    ما و مشتریان ما اطلاعات شخصی را فقط تا زمانی که برای انجام تعهدات قانونی، عملیاتی یا قراردادی، از
                    جمله
                    نگهداری سوابق KYC/AML لازم است، نگه می‌داریم.
                </p>
            </section>

            <section>
                <h2>۸. امنیت</h2>
                <p>
                    ما تدابیر امنیتی فنی، سازمانی و فیزیکی قوی برای محافظت از اطلاعات شخصی حفظ می‌کنیم، از جمله:
                </p>
                <ul>
                    <li>ارتباطات و ذخیره‌سازی داده‌های رمزگذاری شده</li>
                    <li>کنترل‌های دسترسی مبتنی بر نقش</li>
                    <li>نظارت و حسابرسی منظم</li>
                </ul>
                <p>
                    در حالی که ما برای امن نگه داشتن داده‌های شما تلاش می‌کنیم، هیچ سیستم دیجیتالی کاملاً در برابر
                    تهدیدات
                    مصون نیست.
                </p>
            </section>

            <section>
                <h2>۹. انتقال‌های فرامرزی</h2>
                <p>
                    داده‌ها ممکن است خارج از کانادا، از جمله در ایالات متحده ذخیره یا پردازش شوند. ما اقدامات معقولی
                    برای
                    اطمینان از سطوح مشابه حفاظت در آن حوزه‌های قضایی انجام می‌دهیم.
                </p>
            </section>

            <section>
                <h2>۱۰. حقوق شما</h2>
                <p>
                    شما حق دارید:
                </p>
                <ul>
                    <li>به اطلاعات شخصی نگهداری شده درباره خود دسترسی داشته باشید</li>
                    <li>اطلاعات نادرست را اصلاح یا به‌روز کنید</li>
                    <li>رضایت خود را با توجه به محدودیت‌های قانونی پس بگیرید</li>
                </ul>
                <p>
                    لطفاً برای اعمال این حقوق با ارائه‌دهنده خدمات خود (مشتری) تماس بگیرید. پرپال ممکن است در نقش‌های
                    پشتیبانی در صورت لزوم کمک کند.
                </p>
            </section>

            <section>
                <h2>۱۱. استفاده از خدمات توسط افراد زیر سن قانونی</h2>
                <p>
                    خدمات ارائه شده از طریق پلتفرم پرپال برای افراد زیر ۱۸ سال در نظر گرفته نشده است. ما آگاهانه از
                    افراد
                    زیر سن قانونی داده جمع‌آوری نمی‌کنیم.
                </p>
            </section>

            <section>
                <h2>۱۲. پیوندها و ابزارهای شخص ثالث</h2>
                <p>
                    پلتفرم ما ممکن است حاوی پیوندهایی به سایت‌های شخص ثالث باشد یا ابزارهای شخص ثالث را جاسازی کند. ما
                    مسئول
                    شیوه‌های حفظ حریم خصوصی آنها نیستیم. کاربران باید سیاست‌های حفظ حریم خصوصی آن سایت‌ها را جداگانه
                    بررسی
                    کنند.
                </p>
            </section>

            <section>
                <h2>۱۳. تغییرات در این سیاست</h2>
                <p>
                    ما ممکن است این سیاست حفظ حریم خصوصی را هر از گاهی بازنگری کنیم. تاریخ "آخرین به‌روزرسانی"
                    نشان‌دهنده
                    آخرین نسخه است. استفاده از خدمات پس از تغییرات به معنای پذیرش سیاست به‌روز شده است.
                </p>
            </section>

            <section>
                <h2>۱۴. تماس</h2>
                <p>
                    اگر در مورد این سیاست حفظ حریم خصوصی در رابطه با پلتفرم پرپال سؤال یا نگرانی دارید، با ما تماس
                    بگیرید:
                </p>
                <p>
                    12157152 CANADA LTD (پرپال)<br/>
                    ایمیل: <a href="mailto:info@perpal.io">info@perpal.io</a><br/>
                    لطفاً اطلاعات حساس را از طریق ایمیل ارسال نکنید.
                </p>
                <p>
                    برای سؤالات در مورد حساب، تراکنش‌ها یا مدیریت داده‌های شخصی خود، لطفاً مستقیماً از طریق کانال‌های
                    پشتیبانی رسمی با ارائه‌دهنده خدمات خود (مشتری) تماس بگیرید.
                </p>
            </section>
        </div>
    );
};

export default Privacy;